import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@material-ui/core";

import parse from "html-react-parser";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
    },
  },
  title: {
    fontSize: "1rem",
    color: "white",
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
  },
  cardDescription: {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
    },
  },
}));

const Tabular = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {data && (
        <Card variant="outlined">
          {data?.title && (
            <CardHeader
              classes={{
                root: classes.cardHeader,
              }}
              title={
                <Typography className={classes.title}>{data?.title}</Typography>
              }
            />
          )}
          {data?.description && (
            <CardContent>
              <Typography variant="body1" className={classes.cardDescription}>
                {data?.description ? parse(data?.description) : undefined}
              </Typography>
            </CardContent>
          )}
        </Card>
      )}
    </div>
  );
};
export default Tabular;
